import React from 'react';
import { defaultMemoize } from 'reselect';
import {
  ErrorInfo,
  ErrorListContext,
  getToastMessageForErrorCode
} from '../../../../data-catalog-shared';

import { UIActionsToast } from '../../UIActionsToast';

/**
 * Renders the errors in a containing ErrorList React Context as toasts (UIActionsToast).
 * Deduplicates error messages so that, at most, one of any given message is shown.
 */
export class ErrorToasts extends React.Component {

  private readonly memoizedGetUniqueErrorMessages = defaultMemoize(getUniqueErrorMessages);

  private renderToastForMessage(message: string, key: number) {
    switch (message) {
      case getToastMessageForErrorCode('BACKFILL_RUNNING'):
        // show a warning toast instead of a full blown error toast
        return <UIActionsToast key={key} type='warning' text={message} />;
      case getToastMessageForErrorCode('PERMISSIONS_MODE_SWITCHED'):
        // we don't expect to hit this, but if we do, log it and don't render a toast
        console.log(getToastMessageForErrorCode('PERMISSIONS_MODE_SWITCHED'));
        return null;
      default:
        return <UIActionsToast key={key} type='error' text={message} />;
    }
  }

  public override render() {
    return (
      <ErrorListContext.Consumer>
        {errorList => {
          const errorMessages = this.memoizedGetUniqueErrorMessages(errorList.errors);
          return errorMessages.map((message, i) => {
            return this.renderToastForMessage(message, i);
          });
        }}
      </ErrorListContext.Consumer>
    );
  }
}

export function getUniqueErrorMessages(errors: ReadonlyArray<ErrorInfo>): ReadonlyArray<string> {
  const errorMessages: string[] = [];
  const seenErrorMessages: { [key: string]: true } = {};
  for (const error of errors) {
    const errorMessage = error.errorMessage;
    if (!seenErrorMessages[errorMessage]) {
      seenErrorMessages[errorMessage] = true;
      errorMessages.push(errorMessage);
    }
  }
  return errorMessages;
}
